/**
 * SPDX-FileCopyrightText: (c) 2000 Liferay, Inc. https://liferay.com
 * SPDX-License-Identifier: LGPL-2.1-or-later OR LicenseRef-Liferay-DXP-EULA-2.0.0-2023-06
 */

/* eslint-disable sort-keys */

const PortletConstants = {

	// Portlet mode

	EDIT: 'edit',
	HELP: 'help',
	VIEW: 'view',

	// Window state

	MAXIMIZED: 'maximized',
	MINIMIZED: 'minimized',
	NORMAL: 'normal',

	// Resource URL cacheability

	FULL: 'cacheLevelFull',
	PAGE: 'cacheLevelPage',
	PORTLET: 'cacheLevelPortlet',
};

export {PortletConstants};
export default PortletConstants;
